import { motion, useScroll, useTransform, easeInOut } from "framer-motion"
import _ from "lodash"
import * as React from "react"

const ZoomOnScroll = ({ children, before }: React.PropsWithChildren<{ before?: boolean }>) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: before ? ["center start", "end end"] : ["start center", "end end"],
  })

  const scale = useTransform(scrollYProgress, [0, 1], [0.75, 1], {
    ease: easeInOut,
  })
  const borderRadius = useTransform(scrollYProgress, [0, 1], ["25px", "0px"], {
    ease: easeInOut,
  })

  return (
    <div ref={ref}>
      <motion.div style={{ scale, borderRadius, overflow: "clip" }}>{children}</motion.div>
    </div>
  )
}

export default ZoomOnScroll
